<template>
	<div class="container-fluid tml__outer">
		<div :id="id" class="tml">
			<div class="row tml__controls">
				<div class="container">
					<div class="col-xs-2 col-lg-5 tml__date-nav">
						<button class="btn btn-datepicker"><i class="fa fa-calendar"></i></button>
						<button class="btn btn-date-nav" :class="{ 'active': isYesterday}"
								data-action="previous" @click="dateChangeCLick('previous')">{{t('timeline.datepicker.yesterday')}}
						</button>
						<button class="btn btn-date-nav" :class="{ 'active': isToday}"
								data-action="today" @click="dateChangeCLick('today')">{{t('timeline.datepicker.today')}}
						</button>
						<button class="btn btn-date-nav" :class="{ 'active': isTomorrow}"
								data-action="next" @click="dateChangeCLick('next')">{{t('timeline.datepicker.tomorrow')}}
						</button>
					</div>
					<div class="col-xs-10 col-lg-2 tml__date">
						<!-- <span class="tml__date__d">{{ dateFormated }}</span>-->
						<!--<span class="tml__date__t">{{ timeFormated }}</span>-->
					</div>
					<div class="col-lg-5 tml__controls__selector">
						<button class="btn tml__button_selector tml__button_selector_view"
								:class="{ 'active': size === 'compact' }" @click="changeSize('compact')">
							Tout le programme
						</button>
						<button class="btn tml__button_selector tml__button_selector_view"
								:class="{ 'active': size === 'detailed' }" @click="changeSize('detailed')">
							Programme en détails
						</button>
					</div>
				</div>
			</div>
			<div class="timeline_raw" v-show="anyRace">
				<div class="program__content">

					<div class="timeline">
						<div class="timeline__left">
							<div class="timeline__header">
								<b>Réunions</b> <span class="timeline__date">{{dateFormated}}</span>
							</div>
							<div class="timeline__row"
                         :class="[ (index)%2 == 0 ? 'timeline__row--even': 'timeline__row--odd' ]"
                         v-for="(meeting, index) in raceData"
                         :key="'meeting-box__'+meeting.id"
                     >
                        <meeting-card
                            @click.native="meetingClick(meeting)"
                           :meeting="meeting"
                        />
								<timeline-card
										v-if="isMobile && isRowActive(meeting.id)"
										:meeting="meeting"
										:race="race"
										:currentTime="currentTime"
										:size="size"
										@popupChange="popupChange($event)"
										:activePopup="activePopup"
										:trackPos="trackPos"
										v-for="race in meeting.races"
										:key="'race'+race.id"
										:class="{ 'not-premium': !isPremiumRace(race) }"
										:style="'left: '+calcPolePosition(race.time)+'px'"
								></timeline-card>
							</div>
						</div><!-- /.timeline__left -->
						<div class="timeline__right" v-if="!isMobile" @mouseleave="dragEnd($event)">
							<div class="timeline__arrow">
								<a class="timeline__arrow__prev pointer" @click="trackPosSet(racePillWidth*-1)"><span class="visually-hidden">Précédent</span></a>
								<span class="timeline__arrow__next pointer" @click="trackPosSet(racePillWidth)"><span class="visually-hidden">Suivant</span></span>
							</div><!-- /.timeline__arrow -->

							<!--v-on:wheel.prevent="trackScroll($event)"-->
							<div class="timeline__wrapper"

								 v-on:touchmove.prevent="trackScroll($event)"
								 @touchstart.prevent="touchStart($event)"
								 @mousemove="dragMove($event)"
								 @mouseup ="dragEnd($event)"
								 @mousedown="dragStart($event)"
								 @dragstart="dragStart($event)"
							>

								<div class="timeline__track" :style="trackStyle">
									<div class="timeline__header">
										<div class="timeline__mark"
											 v-for="mark in timeline"
											 :key="'tml-mark_'+mark.time"
											 :style="'left: '+mark.pos+'px'">
											<div class="timeline__mark__label">
												{{formatToTime(mark.time)}}
											</div>
										</div>


									</div><!-- /.timeline__header -->

									<div class="timeline__row "
										 :class="[ (index)%2 === 0 ? 'timeline__row--even': 'timeline__row--odd' ]"
										 v-for="(meeting, index) in raceData"
										 :key="'meeting-row__'+meeting.id">
										<timeline-card
												:meeting="meeting"
												:race="race"
												:currentTime="currentTime"
												:size="size"
												@popupChange="popupChange($event)"
												:activePopup="activePopup"
												:trackPos="trackPos"
												v-for="race in meeting.races"
												:key="race.id"
												:class="{ 'not-premium': !isPremiumRace(race) }"
												:style="'left: '+calcPolePosition(race.time)+'px'"
										></timeline-card>
									</div><!-- /.timeline__row -->

									<div class="timeline__cursor" v-if="cursorPosition >= 0" :style="'left: '+cursorPosition+'px;'">
										<div class="timeline__cursor__date">{{formatToTime(currentTime)}}</div>
									</div>
									<div class="timeline__overlay" v-if="overlayWidth > 0" :style="'width: '+overlayWidth+'px;'"></div>
								</div><!-- /.timeline__track -->

							</div><!-- /.timeline__wrapper -->

						</div><!-- /.timeline__right -->
					</div><!-- /.timeline -->

				</div>
			</div>
			<div class="row tml__table__no-races" v-if="!anyRace">
				{{ t("timeline.norace") }}
			</div>
		</div>
	</div>
</template>
<script>
	import Vuex from 'vuex';
	import $ from 'jquery';

	import TimelineCard from './timeline-card';
   import MeetingCard from "@/components/race/timeline/meeting-card";

	// eslint-disable-next-line
	const bsDatepicker = require('bootstrap-datepicker');


	var moment = require('moment-timezone');
	require('moment/locale/fr');

	export default {
		name: 'Timeline',

		components: {
			TimelineCard,
         MeetingCard
		},
		props: [
			'initialDate'
		],
		data() {
			return {
				//data: null,
				id: '',
				//date: new Date(),
				size: 'compact', // 'compact' or 'detailed'
				min: new Date(),
				max: new Date(),
				updateInterval: null,

				sContainer: '',
				previous: null,


				//racePillWidth: 240, // in pixels, default width for big pill

				defaultMinDiff: 1800000, //Default timeline diff beetween poles  = 30 minutes (30*60*1000)
				currentTime: new Date(),
				currentTimeInterval: null,

				activePopup: null,
				trackPos: 0,
				touchPrevX: 0,
				drag: false,

				lastCurSet: '0000-00-00',


				activeMobileRow: null,
			}
		},
		created() {
			setTimeout(() => {
				if (this.ruller) {
					this.ruller.setOptions({moveable: true});
				}

			}, 500);

		},
		beforeDestroy() {
			//this.destroyLinePlugin();
			clearInterval(this.currentTimeInterval)
		},
		computed: {




			//Current active date
			date: {
				get() {
					return this.$store.getters.selectedMeetingDate;
				},
				set(value) {
					this.$store.commit('changeTimelineDate', value)
				}
			},

			dateFormated() {
				return moment(this.date).format('DD MMMM YYYY');
			},
			timeFormated() {
				if (this.daysBetween(this.date, new Date()) === 0) {
					return new Date().getHours() + 'h' + new Date().getMinutes();
				} else {
					return '';
				}
			},
			isToday() {
				return this.daysBetween(new Date(), this.date) === 0;
			},
			isYesterday() {
				return this.daysBetween(new Date(), this.date) === -1;
			},
			isTomorrow() {
				return this.daysBetween(new Date(), this.date) === 1;
			},
			//Race data
			raceData: {
				get() {
					return this.$store.getters.currentRaceData;
				},
				set() {
					console.error('REMOVE THIS METHOD!!!!');
					//this.$store.commit('changeTimelineRace', value)
				}
			},
			anyRace: function () {
				return this.raceData && this.raceData !== null && this.raceData.length > 0;
			},

			racePillWidth(){
				switch (this.size){
					case ('detailed'):
						return '180';
					case ('compact'):
						return '65';
				}
				return 0;
			},
			period(){
				let period = {
					minUTC: 0,
					maxUTC: 0,
					minDiff: this.defaultMinDiff,

					minRound: 0,
					maxRound: 0
				};

				if(this.raceData){
					for (let meting of this.raceData){

						let temp = meting.races.slice().sort((a, b)=>{

							return moment(a.time).valueOf() - moment(b.time).valueOf();
						});

						temp.forEach((race, index, array)=>{
							//Get race time in UTC milliseconds
							let rd = moment(race.time).valueOf();

							//Search for minimum period time
							if(rd < period.minUTC || period.minUTC === 0){
								period.minUTC = rd;
							}

							//Check for maximum period time
							if( rd > period.maxUTC){
								period.maxUTC = rd;
							}

							//Search for minimum diff
							if(index+1 < array.length){
								let diff = moment(array[index+1].time).valueOf() - rd;

								if(period.minDiff > diff && diff > 0 ){
									period.minDiff = diff;
								}
							}
						});

					}


					//Search for minimal rounded time with step of 30 minutes
					period.minRound = this.getMinRoundTime(period.minUTC);

					//Search for maximal rounded time with step of 30 minutes
					period.maxRound = this.getMaxRoundTime(period.maxUTC+period.minDiff);
				}

				return period;

			},
			scale(){
				return this.racePillWidth / this.period.minDiff; //Get how much pixels in one milisecond
			},

			timeline(){
				//Build timeline periods for graph

				let line = [];

				//Строим массив вешек на таймлайне
				line.push({
					time: this.period.min,
					pos: 0
				});

				let step = 1800000; // 30 minutes 30*60*1000
				let next = this.period.minRound + step;

				while (next < this.period.maxRound){
					line.push({
						time: next,
						pos: this.calcPolePosition(next)
					});
					next+= step;
				}

				return line;
			},
			timelineLengthPX(){
				return (this.period.maxRound - this.period.minRound) * this.scale;
			},
			trackStyle(){

				if(!this.isMobile){
					return {
						width: this.timelineLengthPX+'px',
						left: this.trackPos+'px'
					}
				}

				return {};


			},
			cursorPosition(){
				let cur = this.currentTime.valueOf();
				if(cur >= this.period.minRound && cur <= this.period.maxRound){
					return  this.calcPolePosition(cur);
				}
				return -1;

			},
			overlayWidth(){
				let cur = this.currentTime.valueOf();
				if(cur <=  this.period.maxRound){
					return 	Math.round((cur - this.period.minRound) * this.scale);
				}else{
					return this.timelineLengthPX;
				}
			},

			isPremium(){
				return this.$route.name === 'TimelinePremium';
			},

			...Vuex.mapState([
				'lang'
			])
		},
		watch: {
			// eslint-disable-next-line
			'$route'(to, from) {
				/*console.log(to);
				this.ruller.setOptions({moveable: false});
				console.log('mmN');
				setTimeout(()=>{
					this.ruller.setOptions({moveable: true});
					console.log('mmw')
				}, 100);*/
			},

			date(date){
				if(date === this.lastCurSet){
					this.lastCurSet = '0000-00-00';
				}
				this.setDatepicker();
			},

			initialDate(date) {
				this.date = date;
			},
			period(per){

				//Watch for timeline periods
				let cur = new Date().valueOf();
				if(per.minRound > 0 && per.minRound <= cur && per.maxRound >= cur  && this.lastCurSet !== this.date){
					setTimeout(()=>{
						this.alignToCurrentTime();
					},300);
				}else if(this.lastCurSet !== this.date){
					this.trackPos = 0;
					this.lastCurSet = this.date;
				}
			},

			'breakpoint.abs': function (val) {
				if(val > 1){
					this.activeMobileRow = null;
				}else{
					this.size = 'detailed';
				}
			}
		},
		mounted() {

			this.currentTimeInterval = setInterval(()=>{
				//Time update interval
				this.currentTime = new Date();
			}, 5000);
			//Set init date

			let today = moment(this.date).toDate();
			today.setHours(0);
			today.setMinutes(0);
			this.min = today;

			today = moment(this.date).toDate();
			today.setHours(23);
			today.setMinutes(59);
			this.max = today;

			//If date predefined
			if (this.initialDate) {
				//Use it
				this.date = this.initialDate;
			} else if (this.raceData === null) {
				//Otherwise use today
				this.date = new Date();
			}


			// create a Timeline
			this.sContainer = this.$el;



			this.setDatepicker(true);

			$(document).on('click', () => {
				this.activePopup = null;
			});


			setTimeout(()=>{
				if(this.isMobile){
					this.size = 'detailed';
				}
			}, 200);

		},

		methods: {
			meetingClick(meeting){
				if(this.isMobile){
					if(this.activeMobileRow !== meeting.id){
						this.activeMobileRow = meeting.id;
						setTimeout(()=>{
							//meeting-

							this.scrollToQuery('#meeting-'+meeting.id);
						}, 100);
					}else{
						this.activeMobileRow = null;
					}

				}
			},

			isRowActive(id){

				return this.isMobile ? this.activeMobileRow === id : true;

			},

			setDatepicker(init){
				let cnt = $(this.sContainer);
				let self = this;
				if(init){
					cnt.find('.btn-datepicker').datepicker({
						language: this.lang,
						todayHighlight: true,
						autoclose: true,
						todayBtn: true
					}).on('changeDate', function (e) {

						self.getSpecificDate(moment(e.date).format('YYYY-MM-DD'));
					});
				}else{
					cnt.find('.btn-datepicker').datepicker('update', new Date(this.date));
				}

			},
			popupChange(val){
				this.activePopup = val;
				/*if(this.activePopup === val){
					this.activePopup = null;
				}else{
					this.activePopup = val;
				}*/
			},
			alignToCurrentTime(){

				//Calculate how far currentTime is from minimal time
				let move =  this.cursorPosition - (this.period.minDiff*this.scale);


				if(move > 0){
					//If it more than minimal gap, than move track
					this.trackPos = move*-1;

					//Save that we already aligned for this day, afterwards it's user responsibility to move
					this.lastCurSet = this.date;
				}
			},
			trackScroll(event){


				let delta = 0;
				if(event.type === 'wheel' || event.type === 'mousewheel'){

					if(typeof event.deltaY === 'undefined'){
						delta = event.wheelDelta; //IE fallback
					}else{
						delta = event.deltaY /*/ 2*/;
					}



				}else if(event.type === 'touchmove'){

					delta = Math.round(this.touchPrevX - event.touches[0].clientX);

					this.touchPrevX = event.touches[0].clientX;
				}

				this.trackPosSet(delta);
			},
			touchStart(event){
				this.touchPrevX = event.touches[0].clientX;
			},

			dragMove(event){
				if(this.drag){

					let delta = Math.round(this.touchPrevX - event.clientX);

					this.touchPrevX = event.clientX;

					this.trackPosSet(delta);
				}
			},
			dragStart(event){
				this.touchPrevX = event.clientX;
				this.drag = true;
			},
			dragEnd(event){
				this.touchPrevX = event.clientX;
				this.drag = false;
			},


			trackPosSet(delta){

				if(!this.isMobile){
					delta = this.trackPos - delta;

					let maxPos = (this.timelineLengthPX - this.$el.querySelector('.timeline__wrapper').clientWidth) * -1;
					delta = Math.round(delta);
					if(delta > 0){
						delta = 0;
					}else if(delta < maxPos){
						delta = maxPos;
					}

					this.trackPos = delta;
				}


			},


			/**
			 * Return position on timeline regardless of Time
			 * */
			calcPolePosition(time){
				let diff = moment(time).valueOf() - this.period.minRound;

				return Math.round(diff * this.scale);

			},

			getMinRoundTime(timeUTC){
				let timeD = new Date(timeUTC);

				timeD.setMinutes(30);
				timeD.setSeconds(0);
				timeD.setMilliseconds(0);

				if(timeD.valueOf() < timeUTC){
					return timeD.valueOf();
				}else{

					return timeD.setMinutes(0);
				}


			},
			getMaxRoundTime(timeUTC){
				let timeD = new Date(timeUTC);

				timeD.setMinutes(30);
				timeD.setSeconds(0);
				timeD.setMilliseconds(0);

				if(timeD.valueOf() > timeUTC){
					return timeD.valueOf();
				}else{

					timeD.setHours(timeD.getHours()+1);
					return timeD.setMinutes(0);
				}


			},

			dateChangeCLick(tgt){
				switch (tgt) {
					case "previous":
						if(!this.isYesterday){
							this.getSpecificDate(moment().subtract(1, 'day').format('YYYY-MM-DD'));
						}
						break;
					case "today":
						if(!this.isToday){
							this.getSpecificDate(moment().format('YYYY-MM-DD'));
						}
						break;
					case "next":
						if(!this.isTomorrow){
							this.getSpecificDate(moment().add(1, 'day').format('YYYY-MM-DD'));
						}
						break;
				}
			},
			changeSize(size) {
				if (this.size !== size) {
					this.size = size;
				}

			},



			getSpecificDate(date) {
				if (typeof date !== 'undefined') {
					//this.$store.commit('changeTimelineDate', date);
					date = moment(date).format('YYYY-MM-DD');
					this.$router.push({name: 'TimelineWithDate', params: {date}})
				}


			},

			daysBetween(first, second) {
				if (first == null || second == null) {
					return null;
				}
				first = new Date(first);
				second = new Date(second);
				// Copy date parts of the timestamps, discarding the time parts.
				var one = new Date(first.getFullYear(), first.getMonth(), first.getDate());
				var two = new Date(second.getFullYear(), second.getMonth(), second.getDate());

				// Do the math.
				var millisecondsPerDay = 1000 * 60 * 60 * 24;
				var millisBetween = two.getTime() - one.getTime();
				var days = millisBetween / millisecondsPerDay;

				// Round down.
				return Math.floor(days);
			},



			isPremiumRace(race){
				return !this.isPremium || (this.isPremium && race.bets.find((el)=> el.premium))
			},


		}
	}
</script>
<style lang="scss">


</style>
